/**
 * 파일명 : com0102m.jsx
 * 설명 : 부서목록 화면
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.0       2020-08-10   윤성수     최초작성
 * 1.1       2024-03-12   기라성     부서상태 활동으로 초기값설정
 * 1.2       2024-03-18   기라성     부서명 콤보로 필터적용    
 */

/************************************************
 * Import 영역  
 ************************************************/
/*  React  */
import React from 'react';

/* Reducer */

import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0102mAction } from '../../../redux/slice/com/com0102m_slice';
import { IInquiryCndsState, IDeptListItemState, IDeptCdState, IDeptStCdState } from '../../../redux/models/com/com0102m_model';


/*  AntD  */
import { Button, Space, Row, Col, Layout, Typography, Collapse, Table, Select } from 'antd';
import { SearchOutlined, CaretRightOutlined } from '@ant-design/icons';

/*  업무  */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 영역
 ************************************************/
const Com0102m = (props:any) => {
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch = useAppDispatch();
    const inquiryCnds  = useAppSelector((state) => state.Com0102m.inquiryCnds);
    const deptDatas    = useAppSelector((state) => state.Com0102m.deptDatas);
    const deptCdList   = useAppSelector((state) => state.Com0102m.deptCdList);
    const deptStCdList = useAppSelector((state) => state.Com0102m.deptStCdList);
    const pageSize     = useAppSelector((state) => state.Com0102m.pageSize);
    const current      = useAppSelector((state) => state.Com0102m.current);
    
    /* Render 변수 선언영역 */
    /* AntD */
    const { Content } = Layout;
    const { Text } = Typography;
    const { Panel } = Collapse;

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     */
    React.useEffect(() => {
        if (!deptStCdList || deptStCdList.length < 1) setDeptStCdList();
        if (!deptCdList   || deptCdList.length < 1)   setDeptCdsList();
    }, []);

    /**
     * 기능 : setDeptStCdList
     * 설명 : 부서상태
     * param : 
     * return : None
     **/
    const setDeptStCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IDeptStCdState[]) => {
                let arrOptions:IDeptStCdState[] = [];

                arrOptions.push({
                    label: '전체',
                    value: '',
                });
                datas.forEach((item:IDeptStCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd,
                    });
                });

                dispatch(Com0102mAction.setDeptStCdList(arrOptions));
                //dispatch(Com0102mAction.setInquiryCnds({ ...inquiryCnds, deptStCd : arrOptions[0].value }));
            }

        };
        common.getComCodeList('006', option);
    }
    
    React.useEffect(() => {
        dispatch(Com0102mAction.setInquiryCnds({ ...inquiryCnds, deptStCd : 'A' }));
        setTimeout(() => {
            fn_Search();
        }, 300);
    }, [deptStCdList]);
    
    /**
     * 기능 : setDeptCdsList
     * 설명 : 부서코드
     * param : 
     * return : None
     **/
    const setDeptCdsList = () => {

        const requestData = {
            deptStCd: 'A'
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRCOMR0005',
            success: (responseData:any) => {
                // 사용자목록 이름순으로 정렬
                responseData.deptItems.sort((a:IDeptCdState, b:IDeptCdState) => (a.deptNm > b.deptNm) ? 1 : -1)
                dispatch(Com0102mAction.setDeptCdList(responseData.deptItems));
            },
        });

    };

    const deptOptions = React.useCallback(() => {
        let arrOptions: IDeptCdState[] = [];

        if (common.isAdmin()) {
            arrOptions.push({label: '전체', value: ''});
        }

        deptCdList.forEach((item:IDeptCdState) => {
            arrOptions.push({
                label: item.deptNm,
                value: item.deptCd
            });
        });

        return arrOptions;
    }, [deptCdList]);

    /* Table Columns */

    const columns = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>부서코드</div>,
                dataIndex: 'deptCd',
                key: 'deptCd',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>부서상태</div>,
                dataIndex: 'deptStNm',
                key: 'deptStNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>상위부서명</div>,
                dataIndex: 'upperDeptNm',
                key: 'upperDeptNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>부서명</div>,
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>상세보기</div>,
                key: 'action',
                render: (text:string, record:IDeptListItemState) => (
                    <Button
                        id='btn_showDetail'
                        name='btn_showDetail'
                        className='background-color-default-button'
                        size='small'
                        onClick={(e) => onClick(e, record)}
                    >
                        상세보기
                    </Button>
                ),
                align: 'center',
                width: '9%',
            },];
            
            return arr;
    }, []);

    /**
     * 기능 : 초기화 이벤트 선언
     * param : 
     */
    const fn_Reset = () => {
        dispatch(Com0102mAction.initState());
    };

    /**
     * 기능 : 결과초기화 이벤트 선언
     * param : 
     */
    const fn_ResetResult = () => {
        dispatch(Com0102mAction.setDeptDatas([]));
    };

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any, record:IDeptListItemState) => {
        console.log('클릭된 행의 데이터:', record);
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btn_Search': {
                fn_ResetResult();
                fn_Search();
                break;
            }

            case 'btn_Reset': {
                fn_Reset();
                break;
            }

            case 'btn_addDept': {
                const accept = (data:[]) => {
                    dispatch(Com0102mAction.setDeptDatas(data));
                }
                const params:any = {};
                params.title = '부서추가';
                params.popupId = 'com0102p';
                params.accept = accept;
                params.width = 700;
                common.openPopup(params);
                break;

            }
            case 'btn_showDetail': {
               
                const params:any = {};
                params.title = '부서관리';
                params.width = 700;
                params.popupId = 'com0102p';
                params.props = record;
                common.openPopup(params);
                
                break;
            }

            default:
        }
    };


    /**
     * 기능 : 검색조회
     * param : 
     */
    const fn_Search = () => {
        dispatch(Com0102mAction.setCurrent(1));

        // 입력파라미터
        const requestData:IInquiryCndsState = {
            ...inquiryCnds,
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd : 'TRCOMR0005',
            success : (responseData:any) => {
                dispatch(Com0102mAction.setDeptDatas(responseData.deptItems));
            },
        });
    };

    /**
     * 기능 : 입력 후 Enter key 입력 시 조회
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */    
    const handleOnKeyUp = (e:any) => {
        if (e.key === 'Enter') {
            fn_Search(); // 조회
        }
    };
    /*
    const handleOnKeyUp = React.useCallback((e:any) => {
        if (e.key === 'Enter') {
            fn_Search(); // 조회
        }
    },[inquiryCnds.rgstUserNm, inquiryCnds.rgstEmpNo]);
    */
    return (
        <>
            <Layout>
                <Content>
                    <Collapse
                        bordered={false}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                        className='site-collapse-custom-collapse'
                    >
                        <Panel header='검색조건' key='1' className='site-collapse-custom-panel'>
                            <Row
                                align='middle'
                                justify='space-between'
                                style={{ marginTop: 10 }}
                            >
                                <Space>
                                    <Col>
                                        <Space>
                                            <label>부서상태</label>
                                            <Select
                                                style={{
                                                    width: 200,
                                                }}
                                                optionFilterProp='label'
                                                options={deptStCdList}
                                                onKeyUp={handleOnKeyUp}
                                                onChange={val => {
                                                    dispatch(Com0102mAction.setInquiryCnds({...inquiryCnds, deptStCd: val}))
                                                }}
                                                value={inquiryCnds.deptStCd}
                                            ></Select>
                                        </Space>
                                    </Col>
                                    <Col>
                                        <Space>
                                            <label>부서</label>
                                            <Select
                                                style={{
                                                    width: 200,
                                                }}
                                                showSearch
                                                optionFilterProp='label'
                                                options={deptOptions()}
                                                onKeyUp={handleOnKeyUp}
                                                onChange={val => {
                                                    dispatch(Com0102mAction.setInquiryCnds({...inquiryCnds, deptCd: val}))
                                                }}
                                                value={inquiryCnds.deptCd}
                                            />
                                        </Space>
                                    </Col>
                                </Space>
                                <Col>
                                    <Space>
                                        <Button
                                            name='btn_Reset'
                                            className='background-color-default-button'
                                            onClick={e => onClick(e, null)}
                                        >
                                            초기화
                                    </Button>
                                        <Button
                                            name='btn_Search'
                                            className='background-color-primary-button'
                                            icon={<SearchOutlined />}
                                            onClick={e => onClick(e, null)}
                                        >
                                            조회
                                    </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                    <Row align='middle' style={{ height: 50 }}>
                        <Col flex='9.5' >
                            <Space>
                                <img className='title-icon' alt='' />
                                <Text strong>부서목록</Text>
                            </Space>
                        </Col>
                        <Col flex='0.5' style={{ marginRight: 15 }}>
                            <Space>
                                
                                <Button
                                    className='background-color-primary-button'
                                    onClick={e => onClick(e, null)}
                                    name='btn_addDept'
                                >
                                    + 부서추가
                                </Button> 
                            </Space>
                        </Col>
                    </Row>
                    <Row>
                        <Table dataSource={deptDatas}
                            key='no'
                            columns={columns()}
                            size='small'
                            style={{width:'100%'}}
                            scroll={{y:550}}
                            pagination={{
                                pageSize: pageSize,
                                current: current,
                                showTotal : () => '총 ' + deptDatas.length + ' 건',
                                onChange: (page, pageSize) => {
                                    dispatch(Com0102mAction.setCurrent(page));
                                    dispatch(Com0102mAction.setPageSize(pageSize));
                                },
                            }}
                        />
                    </Row>
                </Content>
            </Layout>
        </>
    );
};

export default Com0102m;

